<template>
  <div class="fc-demo">
    <header class="fc-demo__head">
      <h1 class="fc-demo__title">FlowCarousel 3D 轮播</h1>
      <p class="fc-demo__desc">
        参数由 carousel-flow-alpha 参考动画逐帧反解得到：透视 1200px、 每轮
        2600ms（位移 533ms）、缓动 cubic-bezier(0.58, 0, 0.45, 1)。
        可以拖拽、点击两侧卡片或下方指示点切换。
      </p>
    </header>

    <section class="fc-demo__stage">
      <FlowCarousel
        ref="carousel"
        :items="items"
        :autoplay="autoplay"
        :interval="interval"
        :duration="duration"
        :frame="frame"
        :show-dots="showDots"
        @change="onChange"
        @select="onSelect"
      />
    </section>

    <section class="fc-demo__panel">
      <div class="fc-demo__row">
        <button type="button" class="fc-demo__btn" @click="prev">上一张</button>
        <button type="button" class="fc-demo__btn" @click="next">下一张</button>
        <button
          type="button"
          class="fc-demo__btn"
          @click="autoplay = !autoplay"
        >
          {{ autoplay ? "暂停自动播放" : "开始自动播放" }}
        </button>
        <button type="button" class="fc-demo__btn" @click="frame = !frame">
          {{ frame ? "隐藏金框" : "显示金框" }}
        </button>
        <button
          type="button"
          class="fc-demo__btn"
          @click="showDots = !showDots"
        >
          {{ showDots ? "隐藏指示点" : "显示指示点" }}
        </button>
      </div>

      <div class="fc-demo__row">
        <label class="fc-demo__field">
          间隔 {{ interval }}ms
          <input
            v-model.number="interval"
            type="range"
            min="800"
            max="6000"
            step="100"
          />
        </label>
        <label class="fc-demo__field">
          位移 {{ duration }}ms
          <input
            v-model.number="duration"
            type="range"
            min="150"
            max="1500"
            step="1"
          />
        </label>
      </div>

      <p class="fc-demo__state">
        当前第 <b>{{ current + 1 }}</b> / {{ items.length }} 张
        <span v-if="lastPicked" class="fc-demo__picked"
          >· 点击了：{{ lastPicked }}</span
        >
      </p>
    </section>
  </div>
</template>

<script>
import FlowCarousel from "@/components/FlowCarousel";
import { carouselItems } from "@/constants/carouselItems";

export default {
  name: "DemoFlowCarousel",
  components: { FlowCarousel },
  data() {
    return {
      // 素材自带标题与金边，这里只传图；需要 DOM 文案时补 title / subtitle 即可
      items: carouselItems,
      autoplay: true,
      interval: 2600,
      duration: 533,
      frame: true,
      showDots: true,
      current: 0,
      lastPicked: ""
    };
  },
  methods: {
    next() {
      this.$refs.carousel.next();
    },
    prev() {
      this.$refs.carousel.prev();
    },
    onChange(index) {
      this.current = index;
    },
    onSelect(item, index) {
      this.lastPicked = item.alt || String(index + 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.fc-demo {
  /* App.vue 在 ≥620px 给 html/body/#app 加了 overflow:hidden !important，
     演示页比视口高，只能自己做滚动容器 */
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 32px 24px 64px;
  box-sizing: border-box;
  background: #0d0d10;
  color: #e8e8ea;
  font-family: -apple-system, "PingFang SC", "Helvetica Neue", "Microsoft YaHei",
    sans-serif;
}

.fc-demo__head {
  max-width: 1200px;
  margin: 0 auto 20px;
}

.fc-demo__title {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 600;
}

.fc-demo__desc {
  margin: 0;
  max-width: 720px;
  font-size: 14px;
  line-height: 1.7;
  color: rgba(232, 232, 234, 0.6);
}

.fc-demo__stage {
  max-width: 1200px;
  margin: 0 auto;
  background: #0d0d10;
}

.fc-demo__panel {
  max-width: 1200px;
  margin: 24px auto 0;
}

.fc-demo__row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 14px;
}

.fc-demo__btn {
  padding: 8px 16px;
  border: 1px solid rgba(200, 164, 108, 0.5);
  border-radius: 999px;
  background: transparent;
  color: #e0c692;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: rgba(200, 164, 108, 0.12);
  }
}

.fc-demo__field {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: rgba(232, 232, 234, 0.7);

  input {
    width: 220px;
  }
}

.fc-demo__state {
  margin: 4px 0 0;
  font-size: 14px;
  color: rgba(232, 232, 234, 0.75);

  b {
    color: #e0c692;
  }
}

.fc-demo__picked {
  color: rgba(232, 232, 234, 0.5);
}
</style>
